<template>
  <tr>
    <td>
      <BaseUserProfile :user-name="userFullName(instructor)" :picture="instructor.profile_picture">
        <template slot="name">
          <div class="ml-2">
            <div class="text-primary font-weight-bold">
              {{ userFullName(instructor) }}
            </div>
            <div class="text-dark mb-2 small">
              {{ instructor.email }}
            </div>
          </div>
        </template>
      </BaseUserProfile>
    </td>
    <td />
    <td class="pl-1">
      <BaseTag :tag="instructor.tag" />
    </td>
    <td class="text-center">
      <div
        v-if="instructor.tag !== $constants.TAG.LU_OWNER && deleteable"
        class="pl-2 pr-2 btn-sm ml-1 mr-1 text-danger cursur-pointer"
        title="Remove"
        @click.prevent.stop="showModal(`ModalRemoveInstructor-${instructor.id}`)"
      >
        <a href="javascript:void(0)" class="text-danger">
          <font-awesome-icon icon="trash-alt" />
        </a>
      </div>
      <ModalRemoveInstructor
        v-if="instructor.tag !== $constants.TAG.LU_OWNER && deleteable"
        :ref="`ModalRemoveInstructor-${instructor.id}`"
        :instructor-name="userFullName(instructor)"
        :instructor-id="instructor.id"
        :instructor-user-id="instructor.userId"
        :channel-urls="channelUrls"
        @removeMember="$emit('removeMember', instructor)"
      />
    </td>
  </tr>
</template>

<script>
import BaseUserProfile from '@/components/base-components/BaseUserProfile';
import BaseTag from '@/components/base-components/BaseTag';
import ModalRemoveInstructor from './ModalRemoveInstructor';

export default {
  components: {
    BaseUserProfile,
    BaseTag,
    ModalRemoveInstructor
  },

  props: {
    instructor: {
      type: Object,
      default: () => ({})
    },

    channelUrls: {
      type: Array,
      default: () => []
    },

    deleteable: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    showModal(modalType) {
      this.$refs[modalType].show(modalType);
    },

    userFullName(user) {
      return `${user.firstname} ${user.lastname}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.cursur-pointer {
  cursor: pointer;
}
</style>
